<!--
 * @Descripttion: 我发起列表
 * @Author: jschen
 * @Date: 2021-09-05 16:39:41
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-24 15:16:13
-->
<template>
    <div v-show="visible" class="approval-content">
        <el-table v-loading="loading" :data="flowRecords" style="width: 100%" :height="255" @row-click="rowFlowClick">
            <el-table-column prop="title" label="流程标题" :show-overflow-tooltip="true"> </el-table-column>
            <!-- <el-table-column prop="approvalUsername" label="当前审批人" width="120" align="center"> </el-table-column> -->
            <el-table-column prop="statusText" label="审核状态" align="center" width="100">
                <template slot-scope="scope">
                    <span class="process-color">{{ scope.row.statusText }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" sortable label="创建时间" width="100" align="center">
                <template slot-scope="scope">
                    <span>{{ format(scope.row.createTime) | dateFilter }}</span>
                </template>
            </el-table-column>
            <div slot="append" style="width:100%;height:30px;"></div>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
    </div>
</template>
<script>
import _ from "lodash";
import { getFlows } from "@/api";
import { formatDate } from "@/libs/mUtils";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            flowRecords: [],
            searchFlowOpt: {
                title: "", // 标题
                current: 1,
                size: 30,
            },
        };
    },
    methods: {
        loadData() {
            this.queryFlows();
        },
        refresh() {
            const { title } = _.cloneDeep(this.searchFlowOpt);
            this.searchFlowOpt = {
                title: title, // 标题
                current: 1,
                size: 30,
            };
            this.loadData();
        },
        changeSearchOps(item) {
            this.searchFlowOpt = {
                ...this.searchFlowOpt,
                ...item,
            };
        },
        rowFlowClick({ url }) {
            window.open(url);
        },
        format(nS, str) {
            return formatDate(nS, str);
        },
        // 我发起
        async queryFlows() {
            this.loading = true;
            try {
                const { body, code, message } = await getFlows({
                    ...this.searchFlowOpt,
                });
                if (code === "0000") {
                    this.flowRecords = body.records;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>

<style lang="scss"></style>
